<template>
	<div>
		<a-form :form="form" :label-col="{ span: 4 }" :wrapper-col="{ span: 8 }" @submit.native.prevent="handleSubmit"
			class="product-tab">
			<!-- 质量认证（品类） -->
			<a-form-item label="质量认证" :auto-link="false">
				<div v-decorator="['zhiliangIds', { rules: [{ required: false, message: '请选择质量认证' }] }]" style="display: none;"></div>
				<div style="display: flex">
					<a-select class="mr12" placeholder="请选择质量认证" show-search option-filter-prop="name" :filter-option="filterOption" v-model="baseInfo.plText" @change="handleChange" :disabled="baseInfo.lang === 'EN'">
						<a-select-option v-for="item of availableZhiliang" :key="item.tagId" :value="item.tagId">
							{{ item.tagName }}
						</a-select-option>
					</a-select>
					<a-button style="width: 100px;margin-left: 20px;" type="primary" @click="addPL" :disabled="baseInfo.lang === 'EN'">+ 新增</a-button>
				</div>
				<div ref="dragPl" style="width:100%;margin-top:8px">
					<div class="size_item" v-for="(item,idx) of plList" :key="item.tagId">
						<span class="left">{{ item.tagName }}</span>
						<a-icon class="right" v-if="baseInfo.lang !== 'EN'" type="delete" style="color:red;cursor:pointer" @click="deletePL(idx)" />
					</div>
				</div>
			</a-form-item>
			<!-- 生产资质（工艺） -->
			<a-form-item v-if="ifFacOrBr=='1'" label="生产资质" :auto-link="false">
				<div v-decorator="['shengchanIds', { rules: [{ required: false, message: '请选择生产资质' }] }]" style="display: none;"></div>
				<div style="display: flex;">
					<a-select placeholder="请选择生产资质" show-search option-filter-prop="name" :filter-option="filterOption" v-model="baseInfo.gyText" @change="handleChange" :disabled="baseInfo.lang === 'EN'">
						<a-select-option v-for="item of availableShengchan" :key="item.tagId" :value="item.tagId">
							{{ item.tagName }}
						</a-select-option>
					</a-select>
					<a-button style="width: 100px;margin-left: 20px;" type="primary" @click="addGY" :disabled="baseInfo.lang === 'EN'">+ 新增</a-button>
				</div>
				<div ref="dragGy" style="width:100%;margin-top:8px">
					<div class="size_item" v-for="(item,idx) of gyList" :key="item.tagId">
						<span class="left">{{ item.tagName }}</span>
						<a-icon class="right" v-if="baseInfo.lang !== 'EN'" type="delete" style="color:red;cursor:pointer" @click="deleteGY(idx)" />
					</div>
				</div>
			</a-form-item>
			<!-- 专利技术（输入型） -->
			<a-form-item label="专利技术">
				<div style="display:flex;">
					<a-input v-model="patentText" placeholder="请输入专利技术" />
					<a-button style="width:100px;margin-left:20px" type="primary" @click="addPatent">+ 新增</a-button>
				</div>
				<div ref="dragPatent" style="width:100%;margin-top:8px">
					<div class="size_item" v-for="(item,idx) of patentList" :key="item">
						<span class="left">{{ item }}</span>
						<a-icon class="right" type="delete" style="color:red;cursor:pointer" @click="delPatent(idx)" />
					</div>
				</div>
			</a-form-item>
			<!-- 特色认证（输入型，仅品牌） -->
			<a-form-item v-if="ifFacOrBr=='2'" label="特色认证">
				<div style="display:flex;">
					<a-input v-model="featuredCertText" placeholder="请输入特色认证" />
					<a-button style="width:100px;margin-left:20px" type="primary" @click="addFeaturedCert">+ 新增</a-button>
				</div>
				<div ref="dragFeaturedCert" style="width:100%;margin-top:8px">
					<div class="size_item" v-for="(item,idx) of featuredCertList" :key="item">
						<span class="left">{{ item }}</span>
						<a-icon class="right" type="delete" style="color:red;cursor:pointer" @click="delFeaturedCert(idx)" />
					</div>
				</div>
			</a-form-item>
			<!-- 特色工艺（输入型） -->
			<a-form-item label="特色工艺">
				<div style="display:flex;">
					<a-input v-model="processText" placeholder="请输入特色工艺" />
					<a-button style="width:100px;margin-left:20px" type="primary" @click="addProcess">+ 新增</a-button>
				</div>
				<div ref="dragProcess" style="width:100%;margin-top:8px">
					<div class="size_item" v-for="(item,idx) of processList" :key="item">
						<span class="left">{{ item }}</span>
						<a-icon class="right" type="delete" style="color:red;cursor:pointer" @click="delProcess(idx)" />
					</div>
				</div>
			</a-form-item>
			<!-- 特色原料（标签选择） -->
			<a-form-item label="特色原料" :auto-link="false">
				<div style="display:flex;">
					<a-select placeholder="请选择特色原料" show-search option-filter-prop="name" :filter-option="filterOption" v-model="baseInfo.rawMaterialText" @change="handleChange" :disabled="baseInfo.lang === 'EN'">
						<a-select-option v-for="item of availableRawMaterial" :key="item.tagId" :value="item.tagId">
							{{ item.tagName }}
						</a-select-option>
					</a-select>
					<a-button style="width:100px;margin-left:20px" type="primary" @click="addRaw" :disabled="baseInfo.lang === 'EN'">+ 新增</a-button>
				</div>
				<div ref="dragRaw" style="width:100%;margin-top:8px">
					<div class="size_item" v-for="(item,idx) of rawMaterialList" :key="item.tagId">
						<span class="left">{{ item.tagName }}</span>
						<a-icon class="right" v-if="baseInfo.lang !== 'EN'" type="delete" style="color:red;cursor:pointer" @click="delRaw(idx)" />
					</div>
				</div>
			</a-form-item>

			<!-- 权威合作（输入型） -->
			<a-form-item label="权威合作">
				<div style="display:flex;">
					<a-input v-model="partnerText" placeholder="请输入权威合作" />
					<a-button style="width:100px;margin-left:20px" type="primary" @click="addPartner">+ 新增</a-button>
				</div>
				<div ref="dragPartner" style="width:100%;margin-top:8px">
					<div class="size_item" v-for="(item,idx) of partnershipList" :key="item">
						<span class="left">{{ item }}</span>
						<a-icon class="right" type="delete" style="color:red;cursor:pointer" @click="delPartner(idx)" />
					</div>
				</div>
			</a-form-item>
			<!-- 核心原料供应商（主营） -->
			<a-form-item label="核心原料供应商">
				<div style="display: flex;">
					<a-select placeholder="请选择核心原料供应商" show-search v-model="baseInfo.zyText" @change="handleChange" :disabled="baseInfo.lang === 'EN'">
						<a-select-option v-for="item of availableSupply" :key="item.businessId" :value="item.businessId">
							{{ item.businessName }}
						</a-select-option>
					</a-select>
					<a-button style="width: 100px;margin-left: 20px;" type="primary" @click="addZY" :disabled="baseInfo.lang === 'EN'">+ 新增</a-button>
				</div>
				<div ref="dragZy" style="width:100%;margin-top:8px">
					<div class="size_item" v-for="(item,idx) of zyList" :key="item.businessId">
						<span class="left">{{ item.businessName }}</span>
						<a-icon class="right" v-if="baseInfo.lang !== 'EN'" type="delete" style="color:red;cursor:pointer" @click="deleteZY(idx)" />
					</div>
				</div>
			</a-form-item>

			<a-form-item v-if="ifFacOrBr=='2'" label="是否支持进出口">
				<a-radio-group v-model="supportsImportExportStatus" :disabled="baseInfo.lang === 'EN'">
					<a-radio :value="true">是</a-radio>
					<a-radio :value="false">否</a-radio>
				</a-radio-group>

			</a-form-item>
			<a-form-item v-if="ifFacOrBr=='2'" label="年销售额">
				<a-input v-model="annualSalesRevenue" placeholder="请输入年销售额" />
			</a-form-item>
			<a-form-item v-if="ifFacOrBr=='2'" label="子品牌">

				<div style="display: flex;">
					<a-select placeholder="请选择子品牌" show-search :disabled="baseInfo.lang === 'EN'" v-model="baseInfo.zppText" @change="handleChange">
						<a-select-option v-for="item of availableZpp" :key="item.businessId" :value="item.businessId">
							{{ item.businessName }}
						</a-select-option>
					</a-select>
					<a-button style="width: 100px;margin-left: 20px;" type="primary" @click="addZYZPP" :disabled="baseInfo.lang === 'EN'">+ 新增</a-button>
				</div>
				<div ref="dragZyZpp" style="width:100%;margin-top:8px">
					<div class="size_item" v-for="(item,idx) of zppList" :key="item.businessId + '_' + idx">
						<span class="left">{{ item.businessName }}</span>
						<a-icon v-if="baseInfo.lang !== 'EN'" class="right" type="delete" style="color:red;cursor:pointer" @click="delZYZPP(idx)" />
					</div>
				</div>

			</a-form-item>
			<a-row v-if="bigModules.length === 0">
				<a-col :span="8" :offset="4" style="margin-bottom: 16px;">
					<a-button type="primary" @click="totalAddBJ">+ 新增编辑项目</a-button>
				</a-col>
			</a-row>
			<!-- 循环渲染所有大模块 -->
			<!-- 循环渲染所有大模块 -->
			<div v-for="(mod, mIdx) in bigModules" :key="mIdx" style="margin-bottom: 20px;">
				<a-row>
					<a-col :span="4">
						<a-input v-model="mod.title" placeholder="输入编辑标题" style="width: 80%; display: inline-block;" />
						<a-icon type="close-circle" style="font-size: 18px; color: #f5222d; cursor: pointer; vertical-align: middle; margin-left: 4px;" @click="delBigModule(mIdx)" />
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="4"></a-col>
					<a-col :span="8">
						<div style="display:flex;gap:12px;margin-bottom:12px">
							<a-input v-model="mod.innerText" placeholder="输入编辑内容" style="flex:1" />
							<a-button type="primary" @click="addInnerItem(mIdx)">+ 新增</a-button>
							<a-button type="primary" @click="totalAddBJ" style="margin-left:12px" v-if="mIdx === bigModules.length - 1">+ 新增编辑项目</a-button>
						</div>

						<!-- 关键修复：ref 正确绑定 -->
						<div :ref="el => { if (el) $refs['dragInner_' + mIdx] = el }">
							<div class="size_item" v-for="(item, iIdx) in mod.innerList" :key="item">
								<span class="left">{{ item }}</span>
								<a-icon class="right" type="delete" style="color:red;cursor:pointer"
									@click="delInnerItem(mIdx,iIdx)" />
							</div>
						</div>
					</a-col>
				</a-row>
			</div>
			<a-row>
				<a-col :span="12" style="text-align: center;"><a-button style="width: 200px;margin-top: 40px;"
						type="primary" html-type="submit">保存</a-button></a-col>
			</a-row>
		</a-form>
	</div>
</template>

<script>
	import {
		factoryQualityApi
	} from "../../../api/index";


	import Sortable from 'sortablejs'
	import {
		ossUpload
	} from "../../../utils/oss";
	import {
		factoryBaseInfoApi
	} from "../../../api/index";

	export default {
		name: "BaseInfoTab",

		props: {
			ifFacOrBr: {
				type: String,
				default: ""
			},
			initialData: Object,
			zhiliangList: { // 质量认证
				type: Array,
				default: () => []
			},
			shengchanList: { // 生产资质
				type: Array,
				default: () => []
			},
			supplyList: { // 核心原料供应商
				type: Array,
				default: () => []
			},
			featuredRawMaterialTags: { // 特色原料标签列表
				type: Array,
				default: () => []
			},
			companyList: { // （工厂列表）
				type: Array,
				default: () => []
			},

		},
		data() {
			return {
				bigModules: [],
				form: this.$form.createForm(this),
				// 本地表单数据
				baseInfo: {},
				// 原始数据（用于对比是否修改）
				originBaseInfo: {},

				plList: [], // 品类列表
				gyList: [], // 工艺列表
				zyList: [], // 主营列表

				list: [{
						tagId: 1,
						tagName: "001"
					},
					{
						tagId: 2,
						tagName: "002"
					},
					{
						tagId: 3,
						tagName: "003"
					}
				],

				// 输入型（专利/特色原料/特色工艺/权威合作）
				patentList: [], // 专利技术
				featuredCertList: [], // 特色认证
				rawMaterialList: [], // 特色原料（存储对象 {tagId, tagName}）
				processList: [], // 特色工艺
				partnershipList: [], // 权威合作
				zppList: [], //子品牌
				patentText: '',
				featuredCertText: '',
				processText: '',
				partnerText: '',
				annualSalesRevenue: "",
				subBrandIds: "",
				supportsImportExportStatus: undefined,
				sortableInstances: {},
			};
		},
		mounted() {
			this.initAllDrag()
		},
		created() {
			this.baseInfo = JSON.parse(JSON.stringify(this.initialData || {}));
			this.originBaseInfo = JSON.parse(JSON.stringify(this.baseInfo));
		},
		watch: {
			// 监听父组件数据更新 → 自动回填
			initialData: {
				deep: true,
				immediate: true,
				handler(val) {
					if (val) {
						this.initFormData(val);
					}
				}
			},
			zhiliangList: {
				deep: true,
				handler() {
					this.syncQualityCertificationList();
				}
			},
			shengchanList: {
				deep: true,
				handler() {
					this.syncProductionQualificationList();
				}
			},
			supplyList: {
				deep: true,
				handler() {
					this.syncSupplyList();
				}
			},
			featuredRawMaterialTags: {
				deep: true,
				handler() {
					this.syncRawMaterialList();
				}
			},
			companyList: {
				deep: true,
				handler() {
					this.syncSubBrandList();
				}
			},
			// 英文版禁用拖拽
			'baseInfo.lang'(newVal, oldVal) {
				this.applySortableDisabled();
			}
		},
		computed: {
			availableZhiliang() {
				const added = this.plList.map(i => String(i.tagId));
				return this.zhiliangList.filter(i => !added.includes(String(i.tagId)));
			},
			availableShengchan() {
				const addedGy = this.gyList.map(i => String(i.tagId));
				return this.shengchanList.filter(i => !addedGy.includes(String(i.tagId)));
			},
			availableSupply() {
				const addedSupply = this.zyList.map(i => String(i.businessId));
				return this.supplyList.filter(i => !addedSupply.includes(String(i.businessId)));
			},
			availableZpp() {
				const addedZpp = this.zppList.map(i => String(i.businessId));
				return this.companyList.filter(i => !addedZpp.includes(String(i.businessId)));
			},
			availableRawMaterial() {
				const added = this.rawMaterialList.map(i => String(i.tagId));
				return this.featuredRawMaterialTags.filter(i => !added.includes(String(i.tagId)));
			}
		},
		methods: { handleChange() { const isModified = JSON.stringify(this.baseInfo) !== JSON.stringify(this.originBaseInfo); this.$emit("dirty", isModified || true); }, 
			mapSavedIds(value, source, idKey) {
				if (!value) return [];
				const ids = String(value).split(',').filter(Boolean);
				const itemMap = {};
				source.forEach(item => {
					itemMap[String(item[idKey])] = item;
				});
				return ids.map(id => itemMap[String(id)]).filter(Boolean);
			},
			syncQualityCertificationList() {
				this.plList = this.mapSavedIds(this.baseInfo.qualityCertificationIds, this.zhiliangList, 'tagId');
			},
			syncProductionQualificationList() {
				this.gyList = this.mapSavedIds(this.baseInfo.productionQualificationIds, this.shengchanList, 'tagId');
			},
			syncSupplyList() {
				this.zyList = this.mapSavedIds(this.baseInfo.businessIds, this.supplyList, 'businessId');
			},
			syncRawMaterialList() {
				this.rawMaterialList = this.mapSavedIds(this.baseInfo.featuredRawMaterials, this.featuredRawMaterialTags, 'tagId');
			},
			syncSubBrandList() {
				this.zppList = this.mapSavedIds(this.baseInfo.subBrandIds, this.companyList, 'businessId');
			},
			// 统一初始化所有拖拽
			// 英文版禁用拖拽
			applySortableDisabled() {
				const disabled = this.baseInfo.lang === 'EN'
				Object.values(this.sortableInstances).forEach(s => {
					if (s && typeof s.option === 'function') {
						s.option('disabled', disabled)
					}
				})
			},
			initAllDrag() {
				// 品类
				this.createDrag('dragPl', this.plList)
				// 工艺
				this.createDrag('dragGy', this.gyList)
				// 主营
				this.createDrag('dragZy', this.zyList)
				// 专利
				this.createDrag('dragPatent', this.patentList)
				// 特色认证
				this.createDrag('dragFeaturedCert', this.featuredCertList)
				// 特色原料
				this.createDrag('dragRaw', this.rawMaterialList)
				// 特色工艺
				this.createDrag('dragProcess', this.processList)
				// 权威合作
				this.createDrag('dragPartner', this.partnershipList)
				// 子品牌
				this.createDrag('dragZyZpp', this.zppList)
				// 给每个大模块内部列表初始化拖拽
				// 动态大模块 —— 修复版
				this.$nextTick(() => {
					this.bigModules.forEach((mod, idx) => {
						const refName = 'dragInner_' + idx
						this.createDrag(refName, mod.innerList)
					})
				})
			},
			// 拖拽通用方法
			createDrag(refName, list) {
				const el = this.$refs[refName]
				if (!el) return
				// 销毁已有实例
				if (el._sortableInstance) {
					el._sortableInstance.destroy()
				}
				el._sortableInstance = Sortable.create(el, {
					animation: 150,
					ghostClass: 'sort-ghost',
					onEnd: (evt) => {
						// 重要：通过 refName 实时读取当前数据数组，避免闭包引用旧数组
						const listNameMap = {
							dragPl: 'plList',
							dragGy: 'gyList',
							dragZy: 'zyList',
							dragPatent: 'patentList',
							dragFeaturedCert: 'featuredCertList',
							dragRaw: 'rawMaterialList',
							dragProcess: 'processList',
							dragPartner: 'partnershipList',
							dragZyZpp: 'zppList',
						}
						let targetList
						if (refName.startsWith('dragInner_')) {
							const idx = parseInt(refName.replace('dragInner_', ''))
							targetList = this.bigModules[idx] ? this.bigModules[idx].innerList : []
						} else {
							targetList = this[listNameMap[refName]]
						}
						if (!targetList) return
						const { oldIndex, newIndex } = evt
						const moveItem = targetList.splice(oldIndex, 1)[0]
						targetList.splice(newIndex, 0, moveItem)
					}
				})
				if (['dragPl', 'dragGy', 'dragRaw', 'dragZy', 'dragZyZpp'].includes(refName)) {
					this.sortableInstances[refName] = el._sortableInstance
					el._sortableInstance.option('disabled', this.baseInfo.lang === 'EN')
				}
			},

			initFormData(data) {
				if (!data) return;
				this.baseInfo = JSON.parse(JSON.stringify(data || {}));
				this.originBaseInfo = JSON.parse(JSON.stringify(this.baseInfo));

				this.syncQualityCertificationList();
				this.syncProductionQualificationList();
				this.syncSupplyList();

				// 4.专利技术 patentList
				this.patentList = this.baseInfo.patentTechnology ? this.baseInfo.patentTechnology.split(';').filter(
					Boolean) : [];
				// 特色认证 featuredCertList
				this.featuredCertList = this.baseInfo.featuredCertifications ? this.baseInfo.featuredCertifications.split(';').filter(
					Boolean) : [];
				this.syncRawMaterialList();
				// 6.特色工艺 processList
				this.processList = this.baseInfo.featuredProcesses ? this.baseInfo.featuredProcesses.split(';').filter(
					Boolean) : [];
				// 7.权威合作 partnershipList
				this.partnershipList = this.baseInfo.authoritativePartnerships ? this.baseInfo.authoritativePartnerships
					.split(';').filter(Boolean) : [];
				this.syncSubBrandList();


				// 品牌专属字段回显
				this.supportsImportExportStatus = this.baseInfo.supportsImportExportStatus ?? undefined;
				this.annualSalesRevenue = this.baseInfo.annualSalesRevenue ?? '';
				this.subBrandIds = this.baseInfo.subBrandIds ?? '';

				// 质量溯源大模块
				if (this.baseInfo.qualityTraceability) {
					try {
						const arr = JSON.parse(this.baseInfo.qualityTraceability);
						this.bigModules = arr.map(item => ({
							title: item.key || '',
							innerText: '',
							innerList: item.value ? item.value.split(';').filter(Boolean) : []
						}));
					} catch (e) {
						this.bigModules = [];
					}
				} else {
					this.bigModules = [];
				}

				// 延迟初始化拖拽（DOM渲染完成）
				this.$nextTick(() => {
					this.initAllDrag();
				});
				// 重置脏数据
				this.$emit('dirty', false);
			},
			onChange(value, selectedOptions) {
				this.baseInfo.province = selectedOptions[0].text
				this.baseInfo.provinceCode = selectedOptions[0].value
				this.baseInfo.city = selectedOptions[1].text
				this.baseInfo.cityCode = selectedOptions[2].value
			},

			filterOption(input, option) {
				return option.componentOptions.children[0].text.toLowerCase().includes(input.toLowerCase());
			},

			// ======================
			// 品类（质量认证）
			// ======================
			addPL() {
				const val = this.baseInfo.plText;
				if (!val) return this.$msg.warning('请选择');
				const exist = this.plList.some(i => i.tagId == val);
				if (exist) return this.$msg.warning('已添加');
				const item = this.zhiliangList.find(i => i.tagId == val);
				if (item) { this.plList.push(item); this.baseInfo.plText = undefined; }
			},
			deletePL(idx) {
                this.$emit("dirty", true);
				this.plList.splice(idx, 1);
			},

			// ======================
			// 工艺（生产资质）
			// ======================
			addGY() {
				const val = this.baseInfo.gyText;
				if (!val) return this.$msg.warning('请选择');
				const exist = this.gyList.some(i => i.tagId == val);
				if (exist) return this.$msg.warning('已添加');
				const item = this.shengchanList.find(i => i.tagId == val);
				if (item) { this.gyList.push(item); this.baseInfo.gyText = undefined; }
			},
			deleteGY(idx) {
                this.$emit("dirty", true);
				this.gyList.splice(idx, 1);
			},

			// ======================
			// 主营（供应商）
			// ======================
			// here444
			addZY() {
				const val = this.baseInfo.zyText;
				if (!val) return this.$msg.warning('请选择');
				const exist = this.zyList.some(i => i.businessId == val);
				if (exist) return this.$msg.warning('已添加');
				const item = this.supplyList.find(i => i.businessId == val);
				if (item) { this.zyList.push(item); this.baseInfo.zyText = undefined; }
			},
			deleteZY(idx) {
                this.$emit("dirty", true);
				this.zyList.splice(idx, 1);
			},
			addZYZPP() {
				// companyList
				// zppList
				const val = this.baseInfo.zppText;
				if (!val) return this.$message.warning('请选择');
				const exist = this.zppList.some(i => i.businessId == val);
				if (exist) return this.$message.warning('已添加');
				const item = this.companyList.find(i => i.businessId == val);
				if (item) {
					this.zppList.push(item);
					this.baseInfo.zppText = undefined;
				}
			},
			// ======================
			// 输入型：专利技术
			// ======================
			addPatent() {
				if (!this.patentText) return;
				this.patentList.push(this.patentText);
				this.patentText = '';
			},
			delPatent(idx) {
                this.$emit("dirty", true);
				this.patentList.splice(idx, 1);
			},
			// 输入型：特色认证
			addFeaturedCert() {
				if (!this.featuredCertText) return;
				this.featuredCertList.push(this.featuredCertText);
				this.featuredCertText = '';
			},
			delFeaturedCert(idx) {
				this.$emit("dirty", true);
				this.featuredCertList.splice(idx, 1);
			},

			// ======================
			// 特色原料（标签选择）
			// ======================
			addRaw() {
				const val = this.baseInfo.rawMaterialText;
				if (!val) return this.$msg.warning('请选择');
				const exist = this.rawMaterialList.some(i => i.tagId == val);
				if (exist) return this.$msg.warning('已添加');
				const item = this.featuredRawMaterialTags.find(i => i.tagId == val);
				if (item) { this.rawMaterialList.push(item); this.baseInfo.rawMaterialText = undefined; }
			},
			delRaw(idx) {
				this.$emit("dirty", true);
				this.rawMaterialList.splice(idx, 1);
			},

			// ======================
			// 输入型：特色工艺
			// ======================
			addProcess() {
				if (!this.processText) return;
				this.processList.push(this.processText);
				this.processText = '';
			},
			delProcess(idx) {
				this.$emit("dirty", true);
				this.processList.splice(idx, 1);
			},

			// ======================
			// 输入型：权威合作
			// ======================
			addPartner() {
				if (!this.partnerText) return;
				this.partnershipList.push(this.partnerText);
				this.partnerText = '';
			},
			delPartner(idx) {
                this.$emit("dirty", true);
				this.partnershipList.splice(idx, 1);
			},

			// ======================
			// 子品牌
			// ======================
			delZYZPP(idx) {
				this.$emit("dirty", true);
				this.zppList.splice(idx, 1);
			},

			// ======================
			// 提交前拼接字符串
			// ======================
			getSubmitData() {
				return {
					categoryIds: this.plList.map(i => i.tagId).join(','),
					craftsmanshipIds: this.gyList.map(i => i.tagId).join(','),
					coreBusinessIds: this.zyList.map(i => i.tagId).join(','),
					patentTechnology: this.patentList.join(';'),
					featuredRawMaterials: this.rawMaterialList.map(i => i.tagId).join(','),
					featuredProcesses: this.processList.join(';'),
					authoritativePartnerships: this.partnershipList.join(';'),
				};
			},
			// ========== 外层：新增大模块 ==========
			totalAddBJ() {
				this.bigModules.push({
					title: '',
					innerText: '',
					innerList: []
				})

				this.$nextTick(() => {
					const newIdx = this.bigModules.length - 1
					this.createDrag('dragInner_' + newIdx, this.bigModules[newIdx].innerList)
				})
			},

			// 删除整个大模块
			delBigModule(mIdx) {
				this.bigModules.splice(mIdx, 1)
			},

			// ========== 每个大模块内部：新增/删除条目 ==========
			addInnerItem(mIdx) {
				const mod = this.bigModules[mIdx]
				if (!mod.innerText) return
				mod.innerList.push(mod.innerText)
				mod.innerText = ''
			},
			delInnerItem(mIdx, iIdx) {
				this.bigModules[mIdx].innerList.splice(iIdx, 1)
			},


			// ======================
			// 提交
			// ======================
			handleSubmit() {
				this.form.validateFields(async (err, values) => {
					if (!err) {
						// 校验新增编辑项目
						for (let i = 0; i < this.bigModules.length; i++) {
							const mod = this.bigModules[i];
							if (!mod.title || !mod.title.trim()) {
								this.$message.warning('编辑项目未填写完整');
								return;
							}
							if (!mod.innerList || mod.innerList.length === 0) {
								this.$message.warning('编辑项目未填写完整');
								return;
							}
						}
						const saved = await this.saveData(values);
						if (saved) this.$message.success('保存成功');
					}
				});
			},

			// 转换 bigModules 为后端需要的 JSON 字符串
			getBigModulesSubmitStr() {
				const result = this.bigModules.map(item => {
					return {
						key: item.title || '',
						value: item.innerList.join(';') // 统一用 ; 分隔
					};
				});
				return JSON.stringify(result);
			},

			async saveData(values) {

				// 工厂入参
				let params1 = {
					"businessLangId": this.initialData.businessLangId,
					"qualityCertificationIds": this.plList.map(i => i.tagId).join(','), //
					"productionQualificationIds": this.gyList.map(i => i.tagId).join(','), //
					"patentTechnology": this.patentList.join(';'), //
					"featuredRawMaterials": this.rawMaterialList.map(i => i.tagId).join(','), //
					"featuredProcesses": this.processList.join(';'), //
					"authoritativePartnerships": this.partnershipList.join(';'), //
					// 供应商
					"businessIds": this.zyList.map(i => i.businessId).join(','), //
					"qualityTraceability": this.getBigModulesSubmitStr(),

					// "supportsImportExportStatus": true,  // true, //是否支持进出口  品牌
					// "annualSalesRevenue": "",  ////年销售额 品牌
					// "subBrandIds": ""  // 子品牌 多个;隔开 品牌
					"featuredCertifications": this.featuredCertList.join(';'),  //特色认证  多个;隔开 品牌
				}

				// 品牌入参

				let params2 = {
					"businessLangId": this.initialData.businessLangId,
					"qualityCertificationIds": this.plList.map(i => i.tagId).join(','), //
					"patentTechnology": this.patentList.join(';'), //

					"featuredRawMaterials": this.rawMaterialList.map(i => i.tagId).join(','), //
					"featuredProcesses": this.processList.join(';'), //
					"authoritativePartnerships": this.partnershipList.join(';'), //
					"productionQualificationIds": this.gyList.map(i => i.tagId).join(','), //
					// 供应商
					"businessIds": this.zyList.map(i => i.businessId).join(','), //
					"qualityTraceability": this.getBigModulesSubmitStr(),

					// "featuredCertifications": "有机认证;绿色食品认证",  // //特色认证  多个,隔开 品牌
					"supportsImportExportStatus": this.supportsImportExportStatus, // true, //是否支持进出口  品牌
					"annualSalesRevenue": this.annualSalesRevenue, ////年销售额 品牌
					"subBrandIds": this.zppList.map(i => i.businessId).join(','), // 子品牌 多个;隔开 品牌
					"featuredCertifications": this.featuredCertList.join(';'),  //特色认证  多个;隔开 品牌
				}
				return factoryQualityApi(this.ifFacOrBr == '1' ? params1 : params2)
					.then((res) => {
						if (res.resultStatus) {
							this.originBaseInfo = JSON.parse(JSON.stringify(this.baseInfo));
							this.$emit('dirty', false);
							this.$emit('saved', { businessLangId: res.resultData });
							return true;
						} else {
							this.$message.error(res.errorMessage || '保存失败');
							return false;
						}
					})
					.catch(() => {
						this.$message.error('保存失败');
						return false;
					})

			},

		},
	};
</script>

<style scoped lang="less">
	.product-tab {
		padding: 16px;
	}

	.mt12 {
		margin-top: 12px;
	}

	.mr12 {
		margin-right: 12px;
	}

	.sort-ghost {
		opacity: 0.5;
		background: #f5f5f5;
	}

	.size_item {
		min-height: 50px;
		height: auto;
		background: #f7f7f7;
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin: 8px 0;
		/* 间距改小，更美观 */
		cursor: move;
		padding: 10px;

		.left {
			flex: 1;
			padding-left: 10px;
			word-break: break-all;
		}

		.right {
			width: 50px;
			text-align: center;
		}
	}

	.ant-form-item {
		margin-bottom: 10px !important;
	}
</style>
